<!-- 门店入库审核 -->
<template>
  <div class="page_content">
    <subComponents ref="showSelectData"></subComponents>
    <processAuditAction ref="processAuditAction"></processAuditAction>
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo"
        @openFormDesign="openFormDesign"></v-button>
      <div class="page_content_top_line">
        <vSearch @searchData="searchData" @openSearchs="openSearch" :getRequestData=getRequestData
          v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
        </vSearch>
      </div>
    </div>
    <div class="page_content_center">
      <el-table size="mini" v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight"
        :key="$store.state.tableNum" border style="width: 100%" highlight-current-row
        @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="40">
        </el-table-column>

        <el-table-column align="center" v-if="tableValye.isShow == 1" show-overflow-tooltip
          :min-width="tableValye.fieldWeight" v-for="(tableValye, tableKey) in pageShowData.jurTableVo
            .jurconfigtable" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField">
          <template slot-scope="scope">
            <span v-if="tableValye.fieldType == 'date'">
              <span v-if="scope.row[tableValye.entityField]">
                {{
                  $common.getLocalTime(scope.row[tableValye.entityField])
                }}
              </span>
            </span>
            <span v-else-if="tableValye.isRift == 1">
              <a @click="toDetail(scope.row[tableValye.riftField])">{{
                scope.row[tableValye.entityField]
              }}</a>
            </span>
            <span v-else-if="tableValye.entityField == 'createTime'">
              <span v-if="scope.row[tableValye.entityField]">
                {{
                  $common.getLocalTime(scope.row[tableValye.entityField])
                }}
              </span>
            </span>
            <el-tag size="mini" v-else-if="tableValye.fieldType == 'formatter'">
							{{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}
						
						</el-tag>
            <span v-else>
              {{ scope.row[tableValye.entityField] }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
        @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <!-- 自定义设计 -->
    <customDesign ref="customDesign"></customDesign>

    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" width="800px">
      <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" />
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      getRequestData: {
        businessId: "",
        opmId: 0,
        storeId: '',
        rmoutBkeId: "",
        page: 1,
        rows: 30,
        start:
          new Date(new Date().toLocaleDateString()).getTime() -
          31 * 24 * 3600 * 1000,
        end:
          new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1,
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: [],
      },
      buttonList: [],
      pageShowData: [],
      selectedDataIndex: 0,
      seId: "",
      dialogTitle: "",
      seWidth: "",
      seTitle: "",
      DialogVisible: false,
      smId: "",
      sField: "",
      parentSearchData: {},
      selectVal: []

    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {

  },
  //方法集合
  methods: {
    handleSelectionChange(val) {
      this.selectVal = val
    },
    // 检索Id, 索引(表格中), 标识
    openSearch(sId, index, type, sField) {
      if (type == 'salesName') {
        if (this.getRequestData.smId == undefined || this.getRequestData.smId == '') {
          return this.$message({
            message: "请先选择单位",
            type: "error",
          });
        } else {
          this.parentSearchData.smId = this.getRequestData.smId
        }
      }
      this.sField = sField;
      this.DialogVisible = true;
      this.seId = sId;
      this.parentSearchData[type] = this.getRequestData[type];
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.getRequestData[item] = val[item]
      })
    },
    // 初始化赋值字段值
    initParamValue(setField) {
      let arr = setField.split(',')
      arr.forEach(item => {
        this.$set(this.getRequestData, item, "")
      })
    },
    // 清空赋值字段
    claerValue(field, pField) {
      if (this.getRequestData[field] == '') {
        this.initParamValue(pField)
      }
    },
    // 检索方案带回数据
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val)
      }
    },

    // 点击穿透字段 传参单号
    toDetail(orderId) {
      if (orderId) {
        // 设置为true 打开穿透组件首页
        var isPenetrate = true; // 设置缓存 存入点击单号
        this.resetSetItem("penetrateOrderId", orderId); // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage(
          {
            //向窗口发送MessageEvent消息
            cmd: "returnFormJson",
            params: {
              isPenetrate,
            }, //参数
          },
          "*"
        );
      }
      this.getPageInfo()
    },
    changeTime(val) {
      if (val) {
        var time = val + 24 * 60 * 60 * 1000 - 1;
        this.getRequestData.end = time;
      }
    },
    //获取状态
    getIsGsp(str, val) {
      try {
        str && str.replace(/\\/g, "");
        let arr = JSON.parse(str);
        let len = arr.length;
        let newStr = "";
        for (let i = 0; i < len; i++) {
          if (arr[i].key == val) {
            newStr = arr[i].value;
            break;
          }
        }
        return newStr;
      } catch (ex) {
        return str;
      }
    },

    // 获取数据列表
    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path);
      let responseData = await this.$http.getJur({
        ids: [pathId.jurId],
      });
      if (responseData.status == 200) {
        this.pageShowData = responseData.result;
        this.pageShowData.jurHead && this.pageShowData.jurHead.jurconfigform.forEach((item) => {
          item.setField && this.initParamValue(item.setField)
        })
        var obj = {}
        if (this.pageShowData.jurHead) {
          obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30, false)
        } else {
          obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30, false)
        }
        for (const key in obj) {
          this.$set(this.getRequestData, key, obj[key])
        }
        this.getButtonList();
        this.getDataList();
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    clear(val) {
      if (val) {
        var arr = val.split(",")
        arr.forEach(item => {
          this.$set(this.getRequestData, item, "")
        })
      }
    },
    // 动作集合
    actionSet(actionData) {
      if (actionData.actionType != 15) {
        if (this.returnData.list == null || this.returnData.list.length <= 0) {
          if (!dataInfo) {
            this.$message({
              message: "暂无数据",
              type: "error",
            });
            return false;
          }
        }
        if (this.selectVal.length == 0) {
          this.$message({
            message: "请先选择您要操作的数据",
            type: "error",
          });
          return false;
        }
        var dataInfo = JSON.parse(
          JSON.stringify(this.returnData.list[this.selectedDataIndex])
        );
      }

      switch (actionData.actionType) {
        case 4:
          var arr = []
          this.selectVal.forEach(item => {
            arr.push(item.rejImId)
          })
          this.$refs["processAuditAction"].openBox(0, arr);
          // this.$refs["processAuditAction"].openBox(0, dataInfo.rejImId);
          break;
        case 5:
          if (this.selectVal.length > 1) {
            this.$message({
              message: "请勾选一条数据",
              type: "error",
            });
            return false;
          }
          this.$refs["processAuditAction"].openBox(1, this.selectVal[0].rejImId);
          // this.$refs["processAuditAction"].openBox(1, dataInfo.rejImId);
          break;
      }
    },
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path);
      this.$refs["customDesign"].openBox(
        pathInfo.jurId,
        this.pageShowData,
        pathInfo.jurName
      );
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1;
      this.getDataList();
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },

    // 获取数据列表
    async getDataList() {
      let responseData = await this.$http.rejectedInQueryTask(this.getRequestData);
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list;
        this.returnData.pages = responseData.result.pages; 
        this.returnData.total = responseData.result.total;
        this.returnData.pageNum = responseData.result.pageNum;
        this.selectedDataIndex = 0;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },

    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton();
      
    },
},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getPageInfo();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}
</style>